import { useQuery } from "@tanstack/react-query";
import localAxios from "../../helpers/localAxios";

const apiHistorialSolicitud = async (id_solicitud) => {
  const { data } = await localAxios.post("/api/sucursalVirtual/obtenerHistorialSolicitud", {
    id_solicitud,
  });
  return data;
};

const useHistorialSolicitud = (id_solicitud, enabled = true) => {
  return useQuery(["historialSolicitud", id_solicitud], () => apiHistorialSolicitud(id_solicitud), {
    enabled: !!id_solicitud && enabled,
  });
};

export default useHistorialSolicitud;
